module.exports = __webpack_public_path__ + "static/img/313_TO8_2308_og.0c72654.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/313_TO8_2308_og.jpg
// module id = Z4M5
// module chunks = 0